// @flow
import { SHOW_ERROR_MESSAGE, HIDE_ERROR_MESSAGE } from 'actions/errorMessage';

const INITIAL_STATE = {
  visible: false,
  playSound: false,
  severity: null,
  message: null,
};

export default function reduce(state = INITIAL_STATE, { type, ...payload }) {
  switch (type) {
    case SHOW_ERROR_MESSAGE: {
      const { message, severity, playSound } = payload;
      return {
        visible: true,
        severity,
        playSound,
        message,
      };
    }

    case HIDE_ERROR_MESSAGE: {
      return {
        ...state,
        severity: null,
        visible: false,
        playSound: false,
      };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/errorMessage.js